import React, { useEffect, useState } from "react";
import { CommonSubmitButtonService } from "../Services";

export const MintButton = React.forwardRef((props, ref) => {
  const [active, setActive] = useState();
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(true);
    };
  }, []);

  CommonSubmitButtonService.loadingState().subscribe((message) => {
    setActive(message);
  });

  return active && props && props !== "" ? (
    <>
      <button
        type={"submit"}
        className={props.className || "btn btn-dark mt-3"}
        {...props}
      >
        {props.label}
        {props.children}
      </button>
    </>
  ) : (
    <>
      <button className={"btn btn-dark mt-3"} disabled {...props}>
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        {"Processing! Please Wait..."}
      </button>
    </>
  );
});
